import { supabase, ReportDoctor } from '../lib/supabase';
import { getTenantId } from '../contexts/TenantContext';

export const reportDoctorService = {
  async getAll(): Promise<ReportDoctor[]> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('report_doctors')
      .select(`
        *,
        doctor:doctors(*)
      `)
      .eq('tenant_id', tenantId)
      .is('deleted_at', null)
      .order('priority', { ascending: false });

    if (error) throw error;
    return data || [];
  },

  async getById(id: string): Promise<ReportDoctor | null> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('report_doctors')
      .select(`
        *,
        doctor:doctors(*)
      `)
      .eq('id', id)
      .eq('tenant_id', tenantId)
      .is('deleted_at', null)
      .single();

    if (error) throw error;
    return data;
  },

  async getByReportType(reportType: string): Promise<ReportDoctor[]> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('report_doctors')
      .select(`
        *,
        doctor:doctors(*)
      `)
      .eq('tenant_id', tenantId)
      .eq('report_type', reportType)
      .eq('status', 'active')
      .is('deleted_at', null)
      .order('priority', { ascending: false });

    if (error) throw error;
    return data || [];
  },

  async create(reportDoctor: Omit<ReportDoctor, 'id' | 'tenant_id' | 'created_at' | 'updated_at' | 'deleted_at' | 'doctor'>): Promise<ReportDoctor> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('report_doctors')
      .insert({ ...reportDoctor, tenant_id: tenantId })
      .select(`
        *,
        doctor:doctors(*)
      `)
      .single();

    if (error) throw error;
    return data;
  },

  async update(id: string, reportDoctor: Partial<ReportDoctor>): Promise<ReportDoctor> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('report_doctors')
      .update(reportDoctor)
      .eq('id', id)
      .eq('tenant_id', tenantId)
      .select(`
        *,
        doctor:doctors(*)
      `)
      .single();

    if (error) throw error;
    return data;
  },

  async delete(id: string): Promise<void> {
    const tenantId = getTenantId();
    const { error } = await supabase
      .from('report_doctors')
      .update({ deleted_at: new Date().toISOString() })
      .eq('id', id)
      .eq('tenant_id', tenantId);

    if (error) throw error;
  }
};
